import { render } from "./OrderProfitBreakdown.vue?vue&type=template&id=940709a2&scoped=true"
import script from "./OrderProfitBreakdown.vue?vue&type=script&lang=js"
export * from "./OrderProfitBreakdown.vue?vue&type=script&lang=js"

import "./OrderProfitBreakdown.vue?vue&type=style&index=0&id=940709a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-940709a2"]])

export default __exports__